import devicesDubai from './final_populated_map.json';
import { setDistricts } from '../redux/districtsSlice';
import { setDevices } from '../redux/devicesSlice';
import { setImages } from '../redux/imagesSlice';
import { setLocalDeviceMarkers, setLocalDistrictMarkers } from '../redux/markerMakerSlice';
import { store } from '../redux/store';
import { setMapSettings } from '../redux/settingsSlice';
import { setTasks } from '../redux/taskManagerSlice';
import { normalizeSettings } from '../utils/json_validator';
import { unstable_batchedUpdates } from 'react-dom';

const addMarkerProp = (devices) => {
  return devices.map(device => {
    return {
      ...device,
      marker: null,
    };
  });
};
  
  const devicesUpdated = {
    ...devicesDubai,
    devices: addMarkerProp(devicesDubai.devices)
  };
  
  const computeDeviceCenter = (devices) => {
    if (!devices || devices.length === 0) return null;
    const sum = devices.reduce((acc, d) => ({
      lat: acc.lat + (d.lat || 0),
      lng: acc.lng + (d.lng || 0),
    }), { lat: 0, lng: 0 });
    return {
      lat: sum.lat / devices.length,
      lng: sum.lng / devices.length,
    };
  };

  const dispatchAllData = (data) => {
    // Normalize settings from flat or nested format
    const settings = normalizeSettings(data.settings);

    // Auto-compute map center from device positions
    const center = computeDeviceCenter(data.devices);
    if (center) {
      settings.map_display_settings.center = center;
    }

    // Batch all dispatches to trigger a single render cycle
    unstable_batchedUpdates(() => {
      store.dispatch(setDevices(data.devices));
      store.dispatch(setDistricts(data.districts));
      store.dispatch(setImages(data.images));
      store.dispatch(setTasks(data.tasks));
      store.dispatch(setMapSettings(settings));
      store.dispatch(setLocalDeviceMarkers(data.devices));
      store.dispatch(setLocalDistrictMarkers(data.districts));
    });
  };

const fetchJsonData = async (fileName) => {
  const response = await fetch(`/json/${fileName}`);
  return response.json();
};

const updateStoreWithJson = async (fileName) => {
  const data = await fetchJsonData(fileName);
  dispatchAllData(data);
};

export const downloadJson = () => {
  const state = store.getState();
  const jsonData = {
    settings: state.settings,
    images: state.images,
    districts: state.districts.districts,
    devices: state.devices.devices,
    tasks: state.taskManager.tasks
  };
  
  const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'map_data.json';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const uploadJson = async (file) => {
  try {
    const text = await file.text();
    const json = JSON.parse(text);
    dispatchAllData(json);
    return true;
  } catch (error) {
    console.error('Error uploading JSON:', error);
    return false;
  }
};

export default updateStoreWithJson;
